import React from 'react'

import Navigation from './header/Navigation.jsx'
import Footer from './footer/Footer.jsx'

export default class Layout extends React.Component {
  constructor () {
    super()
    this.state = {isLoggedIn: 'fdfd'}
  }

  render () {
    return (
        <div>
             <Navigation />
          <div>
            {this.props.children}
          </div>
        </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout.jsx